export default __webpack_public_path__ + "static/media/pakrap-6.50d4bc0a.mp3";